<template>
    <div>
        <mobile-card title-color="#fff">
            <template slot="title">
                订单信息
            </template>

            <template slot="content">
                <div class="flex-form-info">
                    <span>订单号</span>
                    <span>{{detail.orderNo}}</span>
                </div>

                <div class="flex-form-info">
                    <span>金额</span>
                    <span class="money-item">{{detail.allMoney | formatMoney}}</span>
                </div>
            </template>
        </mobile-card>
        <mobile-card title-color="#fff">
            <template slot="title">
                <span>支付方式</span>
                <span class="countdown-line">
                    <span>（请在</span>
                    <span class="countdown-line-red">{{countdown}}</span>
                    <span>内完成支付）</span>
                </span>
            </template>

            <template slot="content">
                <div>
                    <div class="flex-form-info">
                        <span>
                            <van-icon name="wechat"/>
                            微信支付
                        </span>
                        <van-radio name="wx" checked-color="#005423" v-model="checkType"></van-radio>
                    </div>
                </div>
            </template>
        </mobile-card>
        <div class="pay-part">
            <mobile-button class="btn-font btn-pay" borderColor="#005423" color="#ffffff" @click="onSubmit">
                支付
            </mobile-button>
        </div>
    </div>
</template>

<script>
    import MobileButton from "components/mobile-button/index";
    import MobileCard from "components/mobile-card/index"
    import moment from "moment"
    import apiUnpaidFee from "api/unpaid-fee";
    import log from "utils/log";
    import apiChooseFee from "api/choose-fee";

    export default {
        components: {
            MobileCard,
            MobileButton
        },
        computed: {
            type() {
                let t = this.$route.query.type
                return Number(t)
            },
            isAnonymous() {
                return this.type === 3
            },
            api() {
                let flag = this.type
                if (flag === 1) {
                    return apiUnpaidFee
                }
                if (flag === 2) {
                    return apiChooseFee
                }
                // if (flag === 3) {
                //     return apiAnonymousPay
                // }
                return null
            },
            random() {
                return this.$route.query.random
            },
        },
        data() {
            return {
                detail: {
                    orderNo: 'jedklfads',
                    allMoney: 1235465,
                },
                countdown: 0,
                timer: null,
                countMoment: null,
                deadTime: 1000,
                checkType: 'wx',
            }
        },
        methods: {
            getDetail() {
                let param = {
                    random: this.random,
                }
                this.api.data(param).then(res => {
                    this.detail = res.data
                    this.deadTime = this.detail.expireTime
                    // let orderState = res.data.orderState
                    if (this.deadTime) {
                        this.getCountMoment()
                    }
                })
            },
            getCountMoment() {
                let t = Number(this.deadTime)
                this.countMoment = moment(t)
                if (this.timer) {
                    log('this')
                    clearTimeout(this.timer)
                }
                this.timer = setInterval(this.setCountDown, 1000)
            },
            setCountDown() {
                this.countMoment.subtract(1, "seconds")
                let ft = 'mm分ss秒'
                let f = this.countMoment.format(ft)
                this.countdown = f
                if (this.countMoment.valueOf() < 1000) {
                    clearTimeout(this.timer)
                    this.onTimeOut()
                }
            },
            onTimeOut() {
                let msg = '订单已过期，请刷新页面后重新提交订单。3秒后返回首页'
                let that = this
                this.$toast({
                    duration: 3000, // 持续展示 toast
                    forbidClick: true,
                    message: msg,
                    onClose() {
                        let r = {
                            1: "unpaid-fee",
                            2: "choose-fee",
                            3: "anonymous-pay",
                        }
                        that.$router.push({
                            name: r[that.type],
                        })
                    },
                })
            },
            onSubmit() {
                log('submit it')
            }
        },
        activated() {
            this.getDetail()
            // this.getCountMoment()
        },
        mounted() {
        },
        destroyed() {
            clearTimeout(this.timer)
        },

    }
</script>

<style lang='scss' scoped>
    .countdown-line {
        font-size: 14px;
        color: #000000;
        .countdown-line-red {
            color: #AE3118;
        }
    }

    .pay-part {
        width: 30%;
        margin: 0 auto;
    }

    .btn-pay {
        background-color: #005423;
        color: #ffffff;
    }
</style>
